import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Collapse } from '../../primitives/Collapse/index.js';
import { Controls } from '../../primitives/CollapsibleContent/components/Controls.js';
const CollapsibleContentComponent = forwardRef(({
  visibleContent,
  hiddenContent,
  expanded,
  minHeight,
  controls,
  className
}, ref) => {
  return _jsxs("div", {
    className: className,
    ref: ref,
    children: [visibleContent, _jsx(Collapse, {
      minHeight: minHeight,
      in: expanded,
      children: hiddenContent
    }), _jsx(Controls, {
      expanded: expanded,
      shadow: Boolean(controls && (visibleContent && hiddenContent || minHeight)),
      children: controls
    })]
  });
});
export const CollapsibleContent = /*#__PURE__*/_styled(CollapsibleContentComponent, process.env.NODE_ENV === "production" ? {
  target: "em6o5je0"
} : {
  target: "em6o5je0",
  label: "CollapsibleContent"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbGxhcHNpYmxlQ29udGVudC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRc0UiLCJmaWxlIjoiQ29sbGFwc2libGVDb250ZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb2xsYXBzZSB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQ29sbGFwc2UvaW5kZXguanMnO1xuaW1wb3J0IHsgQ29udHJvbHMgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0NvbGxhcHNpYmxlQ29udGVudC9jb21wb25lbnRzL0NvbnRyb2xzLmpzJztcbmNvbnN0IENvbGxhcHNpYmxlQ29udGVudENvbXBvbmVudCA9IGZvcndhcmRSZWYoKHsgdmlzaWJsZUNvbnRlbnQsIGhpZGRlbkNvbnRlbnQsIGV4cGFuZGVkLCBtaW5IZWlnaHQsIGNvbnRyb2xzLCBjbGFzc05hbWUgfSwgcmVmKSA9PiB7XG4gICAgcmV0dXJuIChfanN4cyhcImRpdlwiLCB7IGNsYXNzTmFtZTogY2xhc3NOYW1lLCByZWY6IHJlZiwgY2hpbGRyZW46IFt2aXNpYmxlQ29udGVudCwgX2pzeChDb2xsYXBzZSwgeyBtaW5IZWlnaHQ6IG1pbkhlaWdodCwgaW46IGV4cGFuZGVkLCBjaGlsZHJlbjogaGlkZGVuQ29udGVudCB9KSwgX2pzeChDb250cm9scywgeyBleHBhbmRlZDogZXhwYW5kZWQsIHNoYWRvdzogQm9vbGVhbihjb250cm9scyAmJiAoKHZpc2libGVDb250ZW50ICYmIGhpZGRlbkNvbnRlbnQpIHx8IG1pbkhlaWdodCkpLCBjaGlsZHJlbjogY29udHJvbHMgfSldIH0pKTtcbn0pO1xuZXhwb3J0IGNvbnN0IENvbGxhcHNpYmxlQ29udGVudCA9IHN0eWxlZChDb2xsYXBzaWJsZUNvbnRlbnRDb21wb25lbnQpIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q29sbGFwc2libGVDb250ZW50LmpzLm1hcCJdfQ== */");